import { useEffect, useState } from "react";
import { Package } from "lucide-react";
import api from "../../lib/api";

const STATUS_BADGE = {
  placed: "bg-sky-100 text-sky-700", confirmed: "bg-indigo-100 text-indigo-700",
  packed: "bg-amber-100 text-amber-700", shipped: "bg-violet-100 text-violet-700",
  delivered: "bg-emerald-100 text-emerald-700", cancelled: "bg-red-100 text-red-600",
};

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/shop/my-orders").then((r) => setOrders(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="orders-page">
      <h1 className="font-heading text-2xl font-bold text-navy">My Orders</h1>
      <p className="mt-1 text-sm text-slate-500">Your INDIAFAST Shop orders and their live status.</p>
      <div className="mt-6 space-y-4">
        {loading && <p className="py-10 text-center text-sm text-slate-400">Loading…</p>}
        {!loading && !orders.length && (
          <div className="rounded-2xl border border-slate-200 bg-white p-12 text-center" data-testid="orders-empty">
            <Package className="mx-auto h-10 w-10 text-slate-300" />
            <p className="mt-3 text-sm font-semibold text-navy">No orders yet</p>
            <p className="mt-1 text-xs text-slate-500">Visit the Shop to place your first order.</p>
          </div>
        )}
        {orders.map((o) => (
          <div key={o.id} className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`order-card-${o.order_id}`}>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="font-mono text-sm font-bold text-express">{o.order_id}</p>
                <p className="text-xs text-slate-500">{new Date(o.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</p>
              </div>
              <span className={`rounded-full px-3 py-1 text-xs font-bold uppercase ${STATUS_BADGE[o.status] || STATUS_BADGE.placed}`} data-testid={`order-status-${o.order_id}`}>
                {o.status}
              </span>
            </div>
            <div className="mt-3 divide-y divide-slate-100 rounded-xl bg-slate-50 px-4">
              {o.items.map((i, idx) => (
                <div key={idx} className="flex justify-between py-2 text-sm">
                  <span className="text-slate-700">{i.name} × {i.qty}</span>
                  <span className="font-semibold text-navy">₹{(i.price * i.qty).toFixed(2)}</span>
                </div>
              ))}
            </div>
            <div className="mt-3 flex flex-wrap items-center justify-between gap-2">
              <p className="text-xs text-slate-500">{o.address}, {o.city} — {o.pincode}</p>
              <p className="font-heading text-lg font-extrabold text-navy" data-testid={`order-total-${o.order_id}`}>₹{o.total}</p>
            </div>
            {o.status_log?.length > 1 && (
              <div className="mt-3 border-t border-slate-100 pt-3">
                <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Timeline</p>
                <div className="mt-1.5 flex flex-wrap gap-2">
                  {o.status_log.map((s, idx) => (
                    <span key={idx} className="rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold text-slate-600">
                      {s.status} · {(s.at || "").slice(5, 16).replace("T", " ")}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
